import React from 'react';
import clsx from 'clsx';
import { Tooltip, TooltipTrigger, TooltipContent } from '../ui/tooltip';

export interface LabelProps {
  children: string | React.ReactNode;
  htmlFor?: string | undefined;
  additionalClasses?: string;
  description?: string;
  descriptionExplicit?: boolean;
  hideLabel?: boolean;
  textSize?: 'sm' | 'base' | 'lg';
}

const Label = ({
  children,
  htmlFor,
  additionalClasses,
  description,
  descriptionExplicit,
  hideLabel,
  textSize = 'sm',
}: LabelProps) => {
  return (
    <label
      htmlFor={htmlFor}
      className={clsx(
        { 'absolute w-[1px] h-[1px] -m-[1px] overflow-hidden p-0': hideLabel },
        'text-sm font-bold dark:text-blue-100 text-grey-1000',
        additionalClasses
      )}
    >
      <div
        className={clsx(
          'relative flex items-center gap-2 w-min whitespace-nowrap',
          textSize === 'base' && 'text-base  font-normal dark:text-blue-100 text-grey-1000',
          textSize === 'lg' && 'text-lg  font-bold dark:text-blue-100 text-grey-1000'
        )}
      >
        {children}
        {description && !descriptionExplicit && (
          <Tooltip>
            <TooltipTrigger asChild>
              <span className="material-symbols-outlined text-muted-foreground cursor-help leading-none" style={{ fontSize: '16px' }}>info</span>
            </TooltipTrigger>
            <TooltipContent className="max-w-[300px] text-wrap font-normal bg-popover text-popover-foreground border border-border shadow-md">
              {description}
            </TooltipContent>
          </Tooltip>
        )}
      </div>
      {description && descriptionExplicit && (
        <p className="mt-0.5 mb-1 text-sm font-normal text-muted-foreground text-balance">{description}</p>
      )}
    </label>
  );
};

export default Label;
